import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { withStyles, CircularProgress } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import hubAPI from '../../../services/hubAPI';
import HUBContext from '../../../services/HUBContext';
import NoAuthorization from '../../../helpers/noAuthorization';
import NoSuccess from '../../../helpers/notSuccess';
import BadRequest from '../../../helpers/badRequest';
import { Slide } from '@progress/kendo-react-animation';
const styles = theme => ({});

export class DashboardPowerbi extends Component {
    constructor(props) {
        super(props);

        this.state = {
            companyID: 0,
            status: 'ready',

            deniedView: false,
            requestError: false,
            badRequest: false,
            badRequestResponse: null,

            powerbiToken: null
        }
    }

    getData = () => {
        this.setState({ powerbiToken: null, status: 'loading' });

        let locale = localStorage.getItem('locale');
        if (!locale) locale = 'en-US';
        let language = locale.substring(0, 2);

        hubAPI.get(`/api/v1/Dashboard/${this.props.dashboard.dashboardID}/powerbiinfov2?culture=${locale}`)
            .then(response => {
                this.setState({ powerbiToken: response.data, status: 'ready' }, () => {
                    const models = window['powerbi-client'].models;
                    const powerbi = window['powerbi'];
                    console.log(models);

                    const reportLoadConfig = {
                        type: 'report',
                        tokenType: models.TokenType.Embed,
                        accessToken: this.state.powerbiToken.accessToken,
                        embedUrl: this.state.powerbiToken.embedUrl,
                        //viewMode: models.ViewMode.View,
                        settings: {
                            localeSettings: {
                                language: language,
                                formatLocale: locale
                            },
                            layoutType: models.LayoutType.Custom,
                            customLayout: {
                                displayOption: models.DisplayOption.FitToWidth
                            },
                        }
                    };

                    let report = powerbi.embed(this.rootElement, reportLoadConfig);
                    report.off('loaded');
                    report.on('loaded', () => {
                        console.log('report loaded');

                        //report.removeFilters();
                        /*const basicFilter = models.IBasicFilter = {
                            $schema: "http://powerbi.com/product/schema#basic",
                            target: { table: "DIM_COMPANY", column: "COMPANY_ID" },
                            operator: "In",
                            values: [ this.state.companyID ],
                            filterType: 1, // pbi.models.FilterType.BasicFilter
                            requireSingleSelection: true // Limits selection of values to one.
                        }
                        report.setFilters([basicFilter])
                        .catch(error => { console.log('set filter error', error); })*/

                        this.setState({ filters: [] });
                        report.getFilters()
                            .then(filters => { window['xfilters'] = filters; this.setState({ filters: filters }, () => { console.log(this.state.filters) }) });

                    })

                    report.off('rendered');
                    report.on('rendered', () => { console.log('report rendered') })

                    report.off('error');
                    report.on('error', (error) => { console.log('report error', error) })

                    /*let visual = powerbi.get(this.rootElement);
                    visual.getFilters(models.FiltersLevel.Report)
                    .then(filters => { console.log(filters); })
                    .catch(errors => { console.log(errors); })*/

                    /*report.getFilters()
                    .then(filters => {
                        console.log(filters);
                    });*/
                });
            })
            .catch(error => {
                if (error.response) {
                    switch (error.response.status) {
                        case 400:
                            this.setState({ badRequest: true, badRequestResponse: error.response });
                            break;

                        case 401:
                        case 403:
                            this.setState({ deniedView: true, status: 'ready' });
                            break;

                        default:
                            this.setState({ requestError: true, status: 'ready' });
                            console.log(error.response)
                            break;
                    }

                } else if (error.request) {
                    this.setState({ requestError: true, status: 'ready' });
                    console.log(error.request);
                }
                else
                    this.setState({ requestError: true, status: 'ready' });

                console.log(error);
            });
    }

    componentDidMount() {
        this.setState({
            companyID: this.context.companyID,

            deniedView: false,
            requestError: false,
            badRequest: false,

            powerbiToken: null

        }, () => {
            this.getData();
        });
    }

    componentDidUpdate() {
        if (this.state.companyID !== this.context.companyID) {
            this.setState({

                companyID: this.context.companyID,

                deniedView: false,
                requestError: false,
                badRequest: false,

                powerbiToken: null

            }, () => { this.getData(); })
        }
    }

    onEmbedded(embed) {
        console.log(`Report embedded: `, embed, this);
    }

    render() {
        const { classes } = this.props;

        const noAuthorization = this.state.deniedView ? <NoAuthorization /> : null;
        const noSuccess = this.state.requestError ? <NoSuccess /> : null;
        const badRequest = this.state.badRequest ? <BadRequest response={this.state.badRequestResponse} /> : null;

        return (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ padding: '0px' }}>

                <Slide className={classes.slide}>{noAuthorization}</Slide>
                <Slide className={classes.slide}>{noSuccess}</Slide>
                <Slide className={classes.slide}>{badRequest}</Slide>
                

                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        {this.state.status === 'loading' &&
                            !this.state.powerbiToken &&
                            <CircularProgress />
                        }

                        <div className='powerbi-frame' ref={(ref) => this.rootElement = ref}></div>

                    </Grid>
                </Grid>
            </Grid>
        )

    }

}

DashboardPowerbi.contextType = HUBContext;

export default withStyles(styles)(injectIntl(DashboardPowerbi));